// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
// import TourPackageServices from "../../services/externalServices/tourPackages/TourPackageServices";
// import Skeleton from "react-loading-skeleton"; // Importing Skeleton
// import { TOUR_SLUGS } from "../../const/slugs";
// import { Link } from "react-router-dom";

// export const PackageLists = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true); // New loading state

//   useEffect(() => {
//     fetchPackages();
//   }, []);

//   const fetchPackages = async () => {
//     try {
//       const res = await TourPackageServices.getPackages();
//       console.log("res", res);
//       setPackages(res);
//       setLoading(false); // Set loading to false once the data is fetched
//     } catch (error) {
//       console.error("Error fetching tour packages:", error);
//       setLoading(false); // Set loading to false even if there is an error
//     }
//   };

//   return (
//     <>
//       {/* SEO Meta Tags & Schema Markup */}
//       <Helmet>
//         <title>Hampi Tour Packages from Hospet</title>
//         <meta
//           name="description"
//           content="Hampi Tour Packages - Best offers on Hampi packages at Cruze. Book your next Hampi trip and get exciting deals on Hampi holiday packages."
//         />
//         <script type="application/ld+json">
//           {JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "TravelAgency",
//             name: "Cruze Tours",
//             url: "https://yourwebsite.com",
//             description:
//               "Discover the best tour packages at affordable rates. Visit amazing places with Cruze Tours.",
//             offers: packages.map((pkg) => ({
//               "@type": "Offer",
//               name: pkg.name,
//               price: pkg.price,
//               priceCurrency: "INR",
//               url: `https://yourwebsite.com/package/${pkg.id}`,
//             })),
//           })}
//         </script>
//       </Helmet>

//       {/* Tour Packages List */}
//       <section className="container mx-auto p-6">
//         <h1 className="text-center mb-6 text-4xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
//           Explore the Best Hampi Tour Packages
//         </h1>
//         <p className="text-center text-lg text-gray-700 mb-8">
//           Discover affordable and exciting <strong>Hampi tour packages</strong>{" "}
//           with our exclusive travel deals. Whether you're exploring the{" "}
//           <strong>UNESCO heritage sites of Hampi</strong>, looking for a
//           reliable <strong> Hospet to Hampi taxi</strong>, or planning a scenic
//           getaway, we offer the best <strong> Hampi taxi services</strong> for a
//           hassle-free experience.
//         </p>

//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//           {/* Conditionally render skeletons or actual content */}
//           {loading
//             ? Array(6) // Display 6 skeleton placeholders while loading
//                 .fill()
//                 .map((_, idx) => (
//                   <div key={idx} className="bg-slate-200 shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition duration-300">
//                     <Skeleton height={200} /> {/* Skeleton for image */}
//                     <div className="p-4">
//                       <Skeleton height={24} width="80%" /> {/* Skeleton for title */}
//                       <Skeleton height={18} width="60%" className="mt-2" /> {/* Skeleton for description */}
//                       <Skeleton height={24} width="40%" className="mt-2" /> {/* Skeleton for price */}
//                       <Skeleton height={36} width="100%" className="mt-4" /> {/* Skeleton for button */}
//                     </div>
//                   </div>
//                 ))
//             : packages.map((pkg) => 
//                 {
//                     const slug = TOUR_SLUGS[pkg._id] || "default-tour";
//                     return(
//                 <article
//                   key={pkg.id}
//                   className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition duration-300"
//                 >
//                   <div className="relative">
//                     <img
//                       src={pkg.thumbnailImage}
//                       alt={`Tour package to ${pkg.name} - ${pkg.description}`}
//                       className="w-full h-48 object-cover"
//                     />
//                     {/* Overlay for short name */}
//                     {/* <p className="absolute bottom-0 bg-black bg-opacity-10 text-white text-md font-semibold p-2 rounded">
//                       {pkg.listHeading}
//                     </p>
//                     <p className="absolute bottom-0 bg-black bg-opacity-10 text-white text-md font-semibold p-2 rounded">
//                       {pkg.listTitle}
//                     </p> */}
//                      <div className="absolute bottom-0 left-0 flex justify-between w-full bg-black bg-opacity-10 p-2 rounded">
//     <p className="text-white text-md font-semibold">{pkg.listHeading}</p>
//     <p className="text-white text-md font-semibold">{pkg.listTitle}</p>
//   </div>
//                   </div>
//                   <div className="p-4 bg-black-50">
//                     <h2 className="text-2xl font-semibold">{pkg.name}</h2>
//                     <p className="text-gray-600 text-sm mt-2">{pkg.listSubheading}</p>
//                     <p className="text-lg font-bold mt-2 text-center">
//                       Starting from <span className="text-green-500">₹{pkg.idealPrice}</span>
//                     </p>
//                     <Link to={`/packages/${slug}`} className="block mt-4 text-center bg-black text-white py-2 rounded-lg">
//                   Book Now
//                 </Link>
//                   </div>
//                 </article>
//               )})}
//         </div>
//       </section>
//     </>
//   );
// };



import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import TourPackageServices from "../../services/externalServices/tourPackages/TourPackageServices";
import Skeleton from "react-loading-skeleton"; // Importing Skeleton
import { TOUR_SLUGS } from "../../const/slugs";
import { useLocation } from "react-router-dom"; 
// import { navigationConstants } from "../../const/navigationConstants"; // Import navigation constants

export const PackageLists = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize navigate hook
  const location = useLocation(); 

  const marginTopClass = location.pathname === "/tour-packages" ? "mt-20 pt-6" : "mt-20 pt-6"; 
  useEffect(() => {
    fetchPackages();
  }, []);

  // const fetchPackages = async () => {
  //   try {
  //     const res = await TourPackageServices.getPackages();
  //           const filtered = res.filter(

  //       (pkg) =>
          
  //         pkg.packageCategory !== "RENTAL" &&
  //         pkg.packageCategory !== "AIRPORT"
  //     );
  //     console.log("filtered")
  //     setPackages(filtered);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching tour packages:", error);
  //     setLoading(false);
  //   }
  // };


  // const fetchPackages = async () => {
  //   const cached = localStorage.getItem("tour_packages");
  //   const cachedTime = localStorage.getItem("tour_packages_time");
  
  //   const isCacheValid =
  //     cached &&
  //     cachedTime &&
  //     Date.now() - parseInt(cachedTime) < 12 * 60 * 60 * 1000; // 12 hours
  
  //   if (isCacheValid) {
  //     setPackages(JSON.parse(cached));
  //     setLoading(false);
  //     return;
  //   }
  
  //   try {
  //     const res = await TourPackageServices.getPackages();
  //     setPackages(res);
  //     localStorage.setItem("tour_packages", JSON.stringify(res));
  //     localStorage.setItem("tour_packages_time", Date.now().toString());
  //   } catch (error) {
  //     console.error("Error fetching tour packages:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchPackages = async () => {
    const cached = localStorage.getItem("tour_packages");
    const cachedTime = localStorage.getItem("tour_packages_time");

    const isCacheValid =
        cached &&
        cachedTime &&
        Date.now() - parseInt(cachedTime) < 12 * 60 * 60 * 1000; // 12 hours

    if (isCacheValid) {
        const parsed = JSON.parse(cached);
        const filtered = parsed.filter(
            (pkg) =>
                pkg.packageCategory !== "RENTAL" &&
                pkg.packageCategory !== "AIRPORT"
        );
        setPackages(filtered);
        setLoading(false);
    }

    try {
        const res = await TourPackageServices.getPackages();
        const filtered = res.filter(
            (pkg) =>
                pkg.packageCategory !== "RENTAL" &&
                pkg.packageCategory !== "AIRPORT"
        );

        // Compare filtered data with cached data
        const isDataChanged = !isCacheValid || !arraysEqual(filtered, JSON.parse(cached));

        if (isDataChanged) {
            setPackages(filtered);
            localStorage.setItem("tour_packages", JSON.stringify(filtered));
            localStorage.setItem("tour_packages_time", Date.now().toString());
        } else {
            setPackages(JSON.parse(cached));
        }
    } catch (error) {
        console.error("Error fetching tour packages:", error);
    } finally {
        setLoading(false);
    }
};

// Helper function to compare arrays
function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (JSON.stringify(arr1[i]) !== JSON.stringify(arr2[i])) return false;
    }
    return true;
}

  
  const goToPackageItinerary = (item) => {
    console.log("item",item)
    navigate(`/packages/${item.slug}`, { state: { selectedPackage: item } });
  };

  return (
    <>
      <Helmet>
        <title>Hampi Tour Packages from Hospet</title>
        <meta
          name="description"
          content="Hampi Tour Packages - Best offers on Hampi packages at Cruze. Book your next Hampi trip and get exciting deals on Hampi holiday packages."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TravelAgency",
            name: "Cruze Tours",
            url: "https://yourwebsite.com",
            description:
              "Discover the best tour packages at affordable rates. Visit amazing places with Cruze Tours.",
            offers: packages.map((pkg) => ({
              "@type": "Offer",
              name: pkg.name,
              price: pkg.price,
              priceCurrency: "INR",
              url: `https://yourwebsite.com/package/${pkg.id}`,
            })),
          })}
        </script>
      </Helmet>

      <section className={`container mx-auto p-6 ${marginTopClass}`}>
        <h1 className="text-center mb-6 text-4xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
          Explore the Best Hampi Tour Packages
        </h1>
        <p className="text-center text-lg text-gray-700 mb-8">
          Discover affordable and exciting <strong>Hampi tour packages</strong> with our exclusive travel deals.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {loading
            ? Array(6)
                .fill()
                .map((_, idx) => (
                  <div key={idx} className="bg-slate-200 shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition duration-300">
                    <Skeleton height={200} />
                    <div className="p-4">
                      <Skeleton height={24} width="80%" />
                      <Skeleton height={18} width="60%" className="mt-2" />
                      <Skeleton height={24} width="40%" className="mt-2" />
                      <Skeleton height={36} width="100%" className="mt-4" />
                    </div>
                  </div>
                ))
            : packages.map((pkg) => {
                const slug = TOUR_SLUGS[pkg._id] || "default-tour";
                return (
                  <article
                    key={pkg.id}
                    className="bg-white shadow-lg rounded-lg overflow-hidden transform hover:scale-105 transition duration-300"
                  >
                    <div className="relative">
                      <img
                        src={pkg.thumbnailImage}
                        alt={`Tour package to ${pkg.name} - ${pkg.description}`}
                        className="w-full h-48 object-cover"
                      />
                       <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute bottom-0 left-0 flex justify-between w-full p-2 rounded">
                        <p className="text-white text-md font-semibold">{pkg.listHeading}</p>
                        <p className="text-white text-md font-semibold">{pkg.listTitle}</p>
                      </div>
                    </div>
                    <div className="p-4 bg-black-50">
                      <h2 className="text-2xl font-semibold">{pkg.name}</h2>
                      <p className="text-gray-600 text-sm mt-2 line-clamp-2 overflow-hidden">{pkg.listSubheading}</p>
                      <p className="text-lg font-bold mt-2 text-center">
                        Starting from <span className="text-green-500">₹{pkg.idealPrice}</span>
                      </p>
                      <button
                        onClick={() => goToPackageItinerary(pkg)}
                        className="block mt-4 text-center bg-black text-white py-2 rounded-lg w-full"
                      >
                        Book Now
                      </button>
                    </div>
                  </article>
                );
              })}
        </div>
      </section>
    </>
  );
};

